module.exports = __webpack_public_path__ + "static/result-mobile-82e29aa5fd42689c4f09620e2ae037f8.svg";